module.exports = __webpack_public_path__ + "static/media/4.c8f76e87.jpg";